import React from 'react';
import { AppStatus } from '../api/client';
import { AlertIcon } from './icons';

interface StatusBannerProps {
  status: AppStatus | null;
  onNavigateToSettings?: () => void;
}

const StatusBanner: React.FC<StatusBannerProps> = ({ status, onNavigateToSettings }) => {
  if (!status || status.warnings.length === 0) {
    return null;
  }

  return (
    <div className="status-banner" role="status">
      <div className="status-banner-inner">
        <AlertIcon className="status-banner-icon" />
        <div className="status-banner-body">
          <strong>Setup Required</strong>
          <ul>
            {status.warnings.map((warning, index) => (
              <li key={index}>{warning}</li>
            ))}
          </ul>
        </div>
        {onNavigateToSettings && (
          <button className="btn btn-sm btn-warning" onClick={onNavigateToSettings}>
            Configure Settings
          </button>
        )}
      </div>
    </div>
  );
};

export default StatusBanner;
